<template>
    <router-view />
</template>

<script>
    export default {
        emits: ['update:showLoading'],

        props: {
            showLoading: {
                type: Boolean,
                required: true,
            },
        },

        mounted() {
            this.$emit('update:showLoading', false);
        },
    };
</script>
